import React from 'react';
import cx from 'classnames';
import { filterDataProps, filterEventHandlerProps } from '@THC/utils/helpers';
import { IconText } from '../IconText';
import styles from './Badge.module.scss';
export const Badge = ({ icon, id, reverse = false, text, variant = 'default', weight = 'bold', ...rest }) => (<div className={cx(styles.badge, styles[variant], styles[weight])} id={id} {...filterDataProps(rest)} {...filterEventHandlerProps(rest)}>
		{icon ? (<IconText icon={icon} reverse={!reverse} text={text} variant={weight === 'bold' ? 'xsmall--heading7' : 'xsmall--small'}/>) : (text)}
	</div>);
